import * as React from 'react';
import i18next from 'i18next';

const icon = require('../../assets/no_requests.svg');

class Error extends React.Component<any> {

    render() {
        const {message} = this.props;
        return (
            <div className='container'>
                {message ? <div className='container'>
                    <div className='search-result__wrapper_error'>
                        <img src={icon} />
                        <div className='search-result__group'>
                            <div className='not-found' style={{textAlign: 'center'}}>{i18next.t('sorry_everything_will_work_soon')}</div>
                        </div>
                    </div>
                </div> : this.props.children}
            </div>
        );
    }
}

export default Error;



// WEBPACK FOOTER //
// ./src/components/Error/ErrorComponent.tsx